import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useDataProvider } from 'src/app/common/utils';
import { PaginateList } from 'src/app/common/types';
import { ParamsProps } from 'src/app/common/components/ParamsProvider';
import { PruTableSortTypeEnum } from 'src/app/common/components/PruTable/PruTable';
import { BdmBatchFileListItem } from '../../../types/opm-pd-bdm-types'; // create batch-files-types.ts in types folder
import { FetchBdmBatchFilesParams, fetchBdmBatchFiles } from '../../../network/opm-pd-bdm'; // create batch-files-crud.ts in types folder
import { isEmpty, formatIOSString } from '../../../utils/commonHelper';

const initialState: FetchBdmBatchFilesParams = {
  page: 1,
  limit: 5,
};

export const batchFilesFilterKeys = ['tab_menu'];

const paramsInitiator = (initialParams?: Record<string, string>): FetchBdmBatchFilesParams => {
  return initialParams
    ? {
        page: 1,
        limit: 5,
        ...initialParams,
      }
    : initialState;
};

export const useBatchFilesListPage = ({ initialParams, onChangeQueryParams }: ParamsProps) => {
  const dispatch = useDispatch();
  const [filterState, setFilterState] = useState<FetchBdmBatchFilesParams>(paramsInitiator(initialParams));
  const [batchFilesList, setBatchFilesList] = useState<PaginateList<BdmBatchFileListItem>>();

  const { isLoading, refreshData } = useDataProvider<PaginateList<BdmBatchFileListItem>>(
    async () => {
      try {
        if (onChangeQueryParams) {
          onChangeQueryParams(filterState);
        }
        const params = Object.fromEntries(
          Object.entries({
            ...filterState,
            submittedAtFrom: formatIOSString(filterState.submittedAtFrom),
            submittedAtTo: formatIOSString(filterState.submittedAtTo),
          }).filter(([, v]) => !isEmpty(v)),
        ) as any;

        return await fetchBdmBatchFiles(params, dispatch);
      } catch (err) {}
    },
    setBatchFilesList,
    false,
  );

  const onSort = (newSortState: { key: string; value?: string }) => {
    const { key, value } = newSortState;
    if (value) {
      let newSort = '';
      switch (value) {
        case PruTableSortTypeEnum.ASC:
          newSort = key;
          break;
        case PruTableSortTypeEnum.DESC:
          newSort = `-${key}`;
          break;
      }
      setFilterState({ ...filterState, sort: newSort });
    } else {
      setFilterState({ ...filterState, sort: undefined });
    }
    refreshData();
  };

  return {
    filterState,
    batchFilesList,
    isLoading,
    setFilterState,
    refreshData,
    onSort,
  };
};
